import MarketoForm from './marketo-form'
import s from './registration-form.module.css'

export default function RegistrationForm({
	pending = false,
	marketoForm,
	destinationUrl,
	...props
}) {
	return (
		<div className={s.container}>
			{pending ? (
				<>
					<h4 className="g-type-display-4">Recording coming soon!</h4>
					<p className="g-type-body">
						This webinar has concluded. Once the recording has been posted,
						you’ll be able to see it here. Recordings are usually available 2 -
						3 days after the date of the live webinar.
					</p>
				</>
			) : (
				<MarketoForm
					webinarId={props.webinarId}
					product={props.product}
					title={props.title}
					marketoForm={marketoForm}
					destinationUrl={destinationUrl}
				/>
			)}
		</div>
	)
}
